import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { SelectField } from "@/components/ui/form/fields/select-field";

import { useVoucherLimitType } from "./hooks";

export const QuestionVoucherLimitType = () => {
	const { onSetVoucherLimitType, voucherLimitType, voucherLimitTypeOptions } = useVoucherLimitType();

	return (
		<QuestionSectionWrapper>
			<SelectField
				value={voucherLimitType.value}
				options={voucherLimitTypeOptions}
				handleValueChange={onSetVoucherLimitType}
			/>
			<p>を制限する</p>
		</QuestionSectionWrapper>
	);
};

QuestionVoucherLimitType.displayName = "QuestionVoucherLimitType";
